import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function VerificaAdesao() {
  const { user, setUser, updateData } = useContext(AccountContext);
  const [atualizar, setAtualizar] = useState(false);
  const navigate = useNavigate();

  async function validaAdesao() {
    await api(`${ENDPOINT}/cache/adesao`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta) {
          const updateResult = await updateData({
            id_cliente_deovita: user.id_cliente_deovita,
            id_contrato: resposta.novo_id_contrato,
            username: user.cpf,
          });
          if (!updateResult.success) {
            return;
          }
          navigate('/dashboard');
        } 
      });
  }

  useEffect(() => {
    validaAdesao();
    const timeout = setInterval(() => {
      validaAdesao();
    }, 30 * 1000);
    return () => {
      if (timeout) clearInterval(timeout);
    };
  }, [setAtualizar]);

  return <></>;
}

export default VerificaAdesao;
